import {
  CustomAxiosType,
  CustomListType,
  DeleteAdmin,
  DeleteMobility,
  DeleteMobilityImage,
  GetReportParams,
  GetRouteParams,
  HealthCheck,
  Mobility,
  MobilityDetail,
  MobilityReportByUser,
  CustomAxiosSingleType,
  PostContactRecordParams,
  PostMobilityParams,
  RouteInfo,
  MobilityInstallDownloadParams,
  GetMobilityCheck,
  MobilityCheck,
} from "./../types/types";
import { client } from "./client";
import { convertLocaleToLang } from "../utils/langUtils";
import { Locale } from "../locales";

const b6t = `NB6T`;

// 현재 locale을 가져오는 헬퍼 함수 (localStorage에서)
const getCurrentLocale = (): Locale => {
  const savedLocale = localStorage.getItem("locale");
  if (savedLocale && ["ko", "en", "zh", "ja", "vi", "es"].includes(savedLocale)) {
    return savedLocale as Locale;
  }
  return "ko"; // 기본값은 한국어
};

interface GetMobility {
  limit: number;
  page: number;
  searchKey?: string;
  mobilityCode?: number;
  area: string;
  sort?: string;
  // 경주 추가
  groupId?: string;
  startDate?: string;
  endDate?: string;
  event_code?: number;
}

// 기기 상세 조회
export const getMobility = async ({
  limit,
  page,
  searchKey,
  mobilityCode = -1,
  area,
  sort,
  groupId,
  startDate,
  endDate,
  event_code,
  lang,
}: GetMobility & { lang?: string }) => {
  const response = await client.post<CustomAxiosType<Mobility>>(
    `/api/mobility` + b6t + `/detail`,
    {
      limit,
      page,
      searchKey,
      mobility_code: mobilityCode,
      area,
      sort,
      groupId,
      startDate,
      endDate,
      event_code,
      lang: lang || convertLocaleToLang(getCurrentLocale()),
    }
  );
  return response.data.result;
};

// 헬스체크
export const getHealthCheck = async ({
  limit,
  page,
  searchKey,
  mobilityCode,
  area,
  sort,
  lang,
}: GetMobility & { lang?: string }) => {
  const response = await client.post<CustomAxiosType<HealthCheck>>(
    `/api/mobility` + b6t + `/healthCheck`,
    {
      area,
      limit,
      mobility_code: mobilityCode,
      page,
      searchKey,
      sort,
      lang: lang || convertLocaleToLang(getCurrentLocale()),
    }
  );
  return response.data.result;
};

// 기기 정보 상세 조회
export const getMobilityDetail = async ({
  idx,
  lang,
}: DeleteAdmin & { lang?: string }) => {
  const response = await client.post<CustomAxiosType<MobilityDetail>>(
    `/api/mobility` + b6t + `/detailInfo`,
    {
      seq: idx,
      lang: lang || convertLocaleToLang(getCurrentLocale()),
    }
  );
  return response.data.result;
};

export const getMobilityReport = async ({
  startDate,
  endDate,
  mobility_seq,
  page,
  limit,
  lang,
}: GetReportParams & { lang?: string }) => {
  const response = await client.post<
    CustomAxiosType<CustomListType<MobilityReportByUser[]>>
  >(`/api/report` + b6t + `/user/use-device`, {
    startDate,
    endDate,
    mobility_seq,
    page,
    limit,
    lang: lang || convertLocaleToLang(getCurrentLocale()),
  });
  return response.data.result;
};

export const getMobilityRoute = async ({
  // date,
  device_pid,
  second,
  seq,
  lang,
}: GetRouteParams & { lang?: string }) => {
  const response = await client.post<CustomAxiosType<RouteInfo[]>>(
    `/api/report` + b6t + `/user/use-device/route`,
    {
      // date,
      device_pid,
      second,
      seq,
      lang: lang || convertLocaleToLang(getCurrentLocale()),
    }
  );
  return response.data.result;
};

export const postContactRecord = async ({
  admin_idx,
  mobility_seq,
  phone,
  reader_name,
  who,
  name,
}: PostContactRecordParams) => {
  const response = await client.post(`/api/mobility` + b6t + `/contact`, {
    admin_idx,
    mobility_seq,
    phone,
    reader_name,
    who,
    name,
  });

  return response.data;
};

// 농기기 등록
export const postMobility = async ({
  device_phone,
  device_pid,
  mobility_name,
  mobility_type_code,
  phone,
}: PostMobilityParams) => {
  const response = await client.post(`/api/mobility` + b6t, {
    device_phone,
    device_pid,
    mobility_name,
    mobility_type_code,
    phone,
  });
  return response.data;
};

// 농기기 삭제
export const deleteMobility = async ({ seq }: DeleteMobility) => {
  const response = await client.post<CustomAxiosType<{}>>(
    `/api/mobility` + b6t + `/delete`,
    {
      seq,
    }
  );
  return response.data;
};

// 농기기 수정
export const putMobility = async ({
  device_phone,
  device_pid,
  device_seq,
  mobility_name,
  mobility_type_code,
  phone,
}: PostMobilityParams) => {
  const response = await client.post<CustomAxiosType<{}>>(
    `/api/mobility` + b6t + `/patch`,
    {
      device_phone,
      device_pid,
      device_seq,
      mobility_name,
      mobility_type_code,
      phone,
    }
  );
  return response.data;
};

// 농기기 일괄등록
export const postMultipleDevices = async (data: FormData) => {
  const response = await client.post<CustomAxiosSingleType>(
    `/api/mobility` + b6t + `/Excel`,
    data
  );
  return response.data;
};

// 농기기 이미지 수정
export const putMobileImage = async (payload: FormData) => {
  const response = await client.post<CustomAxiosSingleType>(
    `/api/mobility` + b6t + `/image/patch`,
    payload,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

// 농기기 이미지 삭제
export const deleteMobileImage = async ({ pid }: DeleteMobilityImage) => {
  const response = await client.post<CustomAxiosType<{}>>(
    `/api/mobility` + b6t + `/imgDel/patch`,
    {
      pid,
    }
  );
  return response.data;
};

// 점검 모드 작동/해제
export const putTestMode = async ({ pid }: DeleteMobilityImage) => {
  const response = await client.post<CustomAxiosType<{}>>(
    `/api/mobility` + b6t + `/testMode/patch`,
    {
      pid,
    }
  );
  return response.data;
};

// 점검 대상 농기기 조회
export const getMobilityCheck = async ({
  limit,
  page,
  lang,
}: GetMobilityCheck & { lang?: string }) => {
  const response = await client.post<
    CustomAxiosType<CustomListType<MobilityCheck[]>>
  >(`/api/mobility` + b6t + `/checkMobility`, {
    limit,
    page,
    lang: lang || convertLocaleToLang(getCurrentLocale()),
  });
  return response.data.result;
};

// 농기기 설치내역 다운로드
export const postMobilityInstallDownload = async (
  params: MobilityInstallDownloadParams
) => {
  const response = await client.post<Blob>(
    `/api/mobility` + b6t + `/install-mobility/download`,
    params,
    {
      responseType: "blob",
    }
  );

  return response;
};